import { render, staticRenderFns } from "./NewFooter.vue?vue&type=template&id=da36d280&"
import script from "./NewFooter.vue?vue&type=script&lang=js&"
export * from "./NewFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports